import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'
import type * as contexts from '../../contexts'
import type { Feature } from '../feature'
import * as models from '../models'

/**
 * When context for user assignment changes, request users for that context
 */
export const requestUsersForAssignment = store.effects.create(
  (feature: Feature, _contexts: contexts.Feature, meFeature: me.Feature) =>
    rxjs
      .combineLatest({
        activeContext: _contexts.selectors.activeEntityContext.asObservable,
        assignmentContext:
          _contexts.selectors.contextForUserAssignment.asObservable,
        currentUser: meFeature.selectors.currentUser.asObservable,
        isEditing: feature.selectors.isEditing.asObservable,
      })
      .pipe(
        rxjs.debounceTime(500),
        rxjs.filter(({ isEditing }) => isEditing),
        rxjs.map(({ activeContext, assignmentContext, currentUser }) =>
          feature.actions.listUsers
            .from('requestUsersForAssignment (effect)')
            .create({
              filters: {
                context: assignmentContext,
                includePlatformUsers:
                  Boolean(currentUser?.isPlatformAdmin) &&
                  models.User.isTenantContext(activeContext),
              },
            }),
        ),
      ),
)
